import { h } from 'preact';
import React, { useContext } from 'react';

import { ButtonSettings } from './ButtonSettings';
import { makeText, languageUsed } from '../../util';
import { useDev } from '../../hooks';

import './Button.css';

export const Button = ({
  component,
  makeChoice,
  dev,
  path,
  language,
  className,
}) => {
  const settings = new ButtonSettings(component.settings);
  const { devActions, devClass, pathString } = useDev(path, dev);
  
  const styles = {
    ...settings.padding,
    ...settings.margin,
    ...settings.border,
    ...settings.font
  };

  /* WIDTH & HEIGHT */
  const { paddingLeft, paddingRight } = settings.padding;
  const { marginLeft, marginRight } = settings.margin;

  styles.width = settings.width.type === 'auto' ? 'auto' : settings.width.value + settings.width.type;
  if (settings.width.type === '%') {
    styles.width = `calc(${settings.width.value}% - ${(paddingLeft + paddingRight + marginLeft + marginRight)}px`;
  };

  styles.background = settings.background;

  const callMakeChoice = () => {
    const choice = component.settings.choice_option.data;
    const choiceType = component.settings.choice_option.type;
    if (choice.button_text) {
      makeChoice(choice.button_text, languageUsed(language, settings, 'text'), choiceType === 'SE');
    };
  };

  const btnText = makeText(dev, settings, 'text', language);

  return (
    <button
      tabindex={settings.startFocus ? 1 : 0}
      title={btnText}
      aria-label={btnText}
      onClick={callMakeChoice}
      onKeyDown={(e) => e.keyCode === 13 && callMakeChoice()}
      className={'message-component message-button no-children' + className + devClass}
      path={pathString}
      style={styles}
      {...devActions}
    >
      {btnText}
    </button>
  );
}
